import { useRouteError } from 'react-router-dom';

function ErrorPage() {
  const errorRoute = useRouteError();
  console.warn(errorRoute);
  return (
    <center className="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{errorRoute?.status || errorRoute?.message || 'Unknown error'}</i>
      </p>
      <code>
        {errorRoute?.error?.message ||
          errorRoute?.stack ||
          'No additional details available'}
      </code>
    </center>
  );
}

export default ErrorPage;
